import firebase from "firebase/compat/app"
import { auth, firestore } from "utils/firebase"
import { getDisplayErrorMessage } from "utils/helpers"

export const login = async (
  email,
  password,
  setEmailError,
  setPasswordError,
  setCurrentUser
) => {
  const querySnapshot = await firestore
    .collection("admins")
    .where("email", "==", email)
    .get()

  if (querySnapshot.docs.length > 0) {
    
    await auth.signInWithEmailAndPassword(email, password)
    .then((userCredential) => {
      setCurrentUser(querySnapshot.docs[0].data().adminId)
    })
    .catch((err) => {
      console.log("error signing in", err)
      //return errors

      if (err.code === "auth/invalid-email") {
        setEmailError("Invalid email address")
      } else {
        setPasswordError("Invalid password")
      }
    })
  } else {
    setEmailError("No ForeverX Admin corresponding to this email address")
  }
}

export const logout = () => {
  auth.signOut().then(() => {
    window.location.reload(false)
  })
}

export const sendPasswordReset = (email) => {
  auth
    .sendPasswordResetEmail(email)
    .then(() => {
      window.alert("Password reset email successfully sent")
    })
    .catch((e) => {
      window.alert(e.message)
      // console.log('error sending password reset', e)
    })
}

export const CURRENT_PASSWORD_ERROR_FIELD = "currentPassword"

const INCORRECT_CURRENT_PASSWORD_CODES = [
  "auth/invalid-credential",
  "auth/wrong-password",
  "auth/invalid-login-credentials",
]

export const changePassword = async (currentPassword, newPassword) => {
  const currentUser = auth.currentUser

  if (!currentUser) {
    throw new Error("You must be signed in to change your password")
  }

  const credential = firebase.auth.EmailAuthProvider.credential(
    currentUser.email,
    currentPassword
  )

  try {
    await currentUser.reauthenticateWithCredential(credential)
    await currentUser.updatePassword(newPassword)
  } catch (error) {
    if (INCORRECT_CURRENT_PASSWORD_CODES.includes(error.code)) {
      const incorrectPasswordError = new Error(
        "Your current password is incorrect"
      )
      incorrectPasswordError.field = CURRENT_PASSWORD_ERROR_FIELD
      throw incorrectPasswordError
    }

    const message = getDisplayErrorMessage(error.code)
    throw new Error(
      message || "Unable to change your password. Try again later."
    )
  }
}
